<template>
  <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    title="修改密码"
    width="700px"
  >
    <div>
      <div class="top g-flex g-flex-cc g-flex-ac">
        <!-- <div class="info">
					<p class="p1">用户ID</p>
					<p class="p2">{{userInfo.id}}</p>
				</div> -->
        <!-- <i class="line"></i> -->
        <div class="info">
          <p class="p1">用户名</p>
          <p class="p2">{{ userInfo.username }}</p>
        </div>
        <i class="line" />
        <div class="info">
          <p class="p1">所属部门</p>
          <p class="p2">{{ userInfo.department }}</p>
        </div>
      </div>
      <div class="bottom g-flex g-flex-cc">
        <div class="form">
          <el-form
            ref="form"
            :model="info"
            :rules="rules"
            label-position="right"
            label-width="114px"
            size="mini"
          >
            <el-form-item
              label="旧密码"
              prop="oldPassword"
            >
              <el-input
                v-model="info.oldPassword"
                type="password"
              />
            </el-form-item>
            <el-form-item
              label="新密码"
              prop="newPassword"
            >
              <el-input
                v-model="info.newPassword"
                type="password"
              />
            </el-form-item>
            <el-form-item
              label="再次输入密码"
              prop="renewPassword"
            >
              <el-input
                v-model="info.renewPassword"
                type="password"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleCancel">取 消</el-button>
      <el-button
        type="primary"
        @click="handleSure"
      >确 定</el-button>
    </div>
  </el-dialog>

</template>
<script>
  let require = { required: true, message: '不可为空', trigger: 'change' };

  export default {
    name: 'header-change-pwd',
    data() {
      return {
        userInfo: {
          id: '',
          username: '',
          department: ''
        },
        info: {
          oldPassword: '',
          newPassword: '',
          renewPassword: ''
        },
        rules: {
          oldPassword: [require],
          newPassword: [require],
          renewPassword: [require]
        },
        show: false
      };
    },
    watch: {
      show(v) {
        if (v) {
          this.$axios({
            url: '/user/userPasswordView.htm',
            method: 'get',
          }).then(res => {
            let { id, username, department } = res.data.user;
            this.userInfo = { id, username, department };
          });
        } else {
          this.$emit('destory');
          this.info.oldPassword = '';
          this.info.newPassword = '';
          this.info.renewPassword = '';
        }
      }
    },
    mounted() {

    },
    methods: {
      handleSure() {
        if (this.info.newPassword != this.info.renewPassword) {
          this.$message.error('两次输入密码不一致');
          return;
        }
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$axios({
              url: '/user/changePassword.htm',
              method: 'POST',
              data: this.info
            }).then(res => {
              this.$message.success('修改密码成功');
              this.$emit('sure');
            });
          } else {
            this.$message.error('请注意填写规则');
          }
        });

      },
      handleCancel() {
        this.$emit('close');
      }
    },
  };

</script>
<style lang="scss" scoped>
  .top {
    height: 154px;
    background: #fff;
    border-radius: 6px;

    .info {
      width: 150px;
      height: 100%;
      text-align: center;
      display: inline-block;
      vertical-align: middle;

      p {
        width: 100%;
        height: 22px;
        font-size: 16px;
        color: #333;
        line-height: 22px;
        margin: 40px 0 -10px;

        &.p1 {
          font-weight: 700;
        }
      }
    }

    .line {
      display: inline-block;
      vertical-align: middle;
      width: 1px;
      height: 80px;
      background: #e0e4eb;
    }
  }

  .bottom {
    border-radius: 6px;
    background: #fff;

    .title {
      font-size: 18px;
      color: #333;
      line-height: 25px;
      padding: 20px 0 30px;
      border-bottom: 1px solid #e0e4eb;
      font-weight: 700;
    }

    .form {
      width: 400px;
      margin-top: 20px;

      .el-form-item {
        width: 100%;
        margin-top: 20px;
      }
    }

    .button {
      text-align: center;
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/change-password.vue